import { useState, useEffect, useCallback } from 'react';
import Swiper, { Navigation, Pagination, Thumbs } from 'swiper';
import Modal from '../common/cmpt/modal/Modal';
import HugeGallery from './HugeGallery';

const Gallery = ({ items, breakpoints, video }) => {
  const id = `prod-gallery-id`;
  const idPrev = `${id}-prev`;
  const idNext = `${id}-next`;

  const idThumb = `thumb-gallery-id`;
  const idThumbPrev = `${idThumb}-prev`;
  const idThumbNext = `${idThumb}-next`;

  const idPag = `pag-id`;

  const [modal, setModal] = useState(false);
  const [withVideo, setWithVideo] = useState(false);
  const showModal = useCallback(
    (withPhoto, withVideo) => {
      setModal(true);
      setWithVideo(withVideo);
    },
    [setModal],
  );
  const hideModal = () => setModal(false);

  useEffect(() => {
    const thumbsList = new Swiper(`#${idThumb}`, {
      modules: [Navigation, Thumbs],
      slidesPerView: 5,
      watchOverflow: true,
      breakpoints: breakpoints,
      watchSlidesProgress: true,
      loop: false,
      navigation: {
        prevEl: `#${idThumbPrev}`,
        nextEl: `#${idThumbNext}`,
      },
    });

    const gallery = new Swiper(`#${id}`, {
      modules: [Navigation, Pagination, Thumbs],
      slidesPerGroup: 1,
      loop: items.length > 1,
      thumbs: {
        swiper: thumbsList,
      },
      navigation: {
        prevEl: `#${idPrev}`,
        nextEl: `#${idNext}`,
      },
      pagination: {
        el: `#${idPag}`,
        clickable: true,
      },
    });

    gallery.on('click', () => showModal(true, false));
  }, [showModal, items]);

  if (items.length === 0 && video === null) {
    return <></>;
  }

  return (
    <>
      <div className="swiper clinker-slid" id={id}>
        <div className="swiper-wrapper">
          {items.map((slide, idx) => {
            const { original } = slide;
            return (
              <div className="swiper-slide" key={`slide-${idx}`}>
                <span className="open_modal scr-photo clinker-slid__pic">
                  <img src={original} alt="" />
                </span>
              </div>
            );
          })}
        </div>
        <div id={idPrev} className="prod-gallery-prev prod-gal-ctrl">
          <div className="clinker-button-prev" />
        </div>
        <div id={idNext} className="prod-gallery-next prod-gal-ctrl">
          <div className="clinker-button-next" />
        </div>
      </div>
      <div className="clinker-slid-pag">
        <div className="swiper-pagination" id={idPag}></div>
      </div>
      <div className="clinker-sm__fon">
        {video !== null && (
          <div className="clinker-sm__op">
            <a
              href="#"
              className="scr-video video-act-lin"
              onClick={(evt) => {
                showModal(false, true);
                evt.preventDefault();
                evt.stopPropagation();
                return false;
              }}
            >
              <img src="/static/img/Polygon11.png" alt="" />
            </a>
          </div>
        )}

        <div className="swiper clinker-sm-slid" id={idThumb}>
          <div className="swiper-wrapper">
            {items.map((slide, idx) => {
              const { thumbnail } = slide;
              return (
                <div className="swiper-slide" key={`thumb-${idx}`}>
                  <div className="clinker-small__pic">
                    <img src={thumbnail} alt="" />
                  </div>
                </div>
              );
            })}
          </div>
        </div>
        <div id={idThumbPrev} className="clinker-button-prev" />
        <div id={idThumbNext} className="clinker-button-next" />
      </div>

      {modal && (
        <Modal>
          <HugeGallery
            close={hideModal}
            items={items}
            video={video}
            showVideo={withVideo}
            isOpen={modal}
          />
        </Modal>
      )}
    </>
  );
};

export default Gallery;
